import React, { useState, useCallback, useMemo } from "react"
import { Modal, Form, Input, Button, DatePicker, Flex } from "antd"
import styles from "./index.module.css"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"
import bgMan from "assets/imagesV2/logo_man.svg"
import bgWoman from "assets/imagesV2/logo_woman.svg"
import { useTheme } from "context/AntdThemeContext"
import { themes } from "constants/theme"
import { Delete } from "ui/Icon/DSIcon/Delete"
import IconWithBg from "ui/IconWithBg"
import { useTranslation } from "react-i18next"
import { postWaiverSubmission } from "store/digital-waiver"
import { useDispatch, useSelector } from "react-redux"
import { toaster } from "components/common/Toast"

export default function MinorModal({
  userId,
  id,
  tripBookingId,
  waiver,
  loading,
  visible,
  onCancel,
  onSignDocumentOpen
}) {
  const { loading: postLoading } = useSelector((store) => store?.digitalWaiver) || {}
  const { theme } = useTheme()
  const logoSrc = useMemo(() => (theme === themes.sportswoman ? bgWoman : bgMan), [theme])
  const [form] = Form.useForm()
  const [minors, setMinors] = useState([{ fullName: "", dob: null }])
  console.log(minors, "minorsss")
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const handleAddMinor = useCallback(() => {
    setMinors((prev) => [...prev, { fullName: "", dob: null }])
  }, [])

  const handleDeleteMinor = useCallback((idx) => {
    setMinors((prev) => prev.filter((_, i) => i !== idx))
  }, [])

  const handleMinorChange = useCallback((idx, field, value) => {
    setMinors((prev) => {
      const newMinors = [...prev]
      newMinors[idx] = { ...newMinors[idx], [field]: value }
      return newMinors
    })
  }, [])

  const handleNext = useCallback(async () => {
    try {
      await form.validateFields()
      const formData = new FormData()
      if (minors && minors.length > 0) {
        if (id) {
          formData.append("waiver_submission[shared_waiver_id]", id)
        } else if (userId) {
          formData.append("waiver_submission[user_id]", userId)
        }
        // Only set trip_booking_id once, prefer tripBookingId, then waiver.trip_booking_id
        if (waiver?.trip_booking_id) {
          formData.append("waiver_submission[trip_booking_id]", waiver.trip_booking_id)
        } else if (tripBookingId) {
          formData.append("waiver_submission[trip_booking_id]", tripBookingId)
        }
        formData.append(`waiver_submission[waiver_participants_attributes][0][participant_type]`, "minor")
        formData.append("waiver_submission[submission_for]", "minor")
        minors.forEach((minor, index) => {
          formData.append(`waiver_submission[waiver_participants_attributes][${index}][full_name]`, minor.fullName || "")
          // Format date as DD-MM-YYYY
          const formattedMinorDate = minor.dob ? new Date(minor.dob).toLocaleDateString("en-GB").replaceAll("/", "-") : ""
          formData.append(`waiver_submission[waiver_participants_attributes][${index}][birthdate]`, formattedMinorDate)
        })
      }
      // }
      // setIsModalOpen(true)
      dispatch(postWaiverSubmission(formData)).then((res) => {
        toaster.success(res?.message)
        // Call parent to open SignDocumentModal and pass data
        if (onSignDocumentOpen) {
          onSignDocumentOpen(res?.data?.id, minors)
        }
        // Close minor modal
        handleCancel()
      })
    } catch (err) {
      // Validation errors will be shown by AntD
    }
  }, [form, minors, dispatch])

  const handleCancel = useCallback(() => {
    setMinors([{ fullName: "", dob: null }])
    form.resetFields()
    if (onCancel) onCancel()
  }, [form, onCancel])

  return (
    <>
      <Modal
        maskClosable={false}
        open={visible}
        onCancel={handleCancel}
        footer={null}
        closable={true}
        centered
        width={900}
        className={styles.modalContainer}
      >
        <Form form={form} layout="vertical">
          {minors.map((minor, idx) => {
            const minorHeader = `Minor${idx + 1}`
            const fullNameName = `fullName${idx}`
            const dobName = `dob${idx}`
            const showDeleteButton = minors.length > 1

            return (
              <React.Fragment key={idx}>
                <div className={`pb-xl ${styles.minorHeader}`}>{minorHeader}</div>
                <div className={styles.formRow}>
                  <div className={styles.formCol}>
                    <LabeledField
                      labelKey={t("embedded.booking_confirmation.full_name")}
                      name={fullNameName}
                      rules={[{ required: true, message: "Enter minor name" }]}
                    >
                      <Input
                        placeholder="Enter minor name"
                        value={minor.fullName}
                        onChange={(e) => handleMinorChange(idx, "fullName", e.target.value)}
                      />
                    </LabeledField>
                  </div>
                  <div className={styles.formCol}>
                    <LabeledField
                      labelKey={t("embedded.booking_confirmation.dob")}
                      name={dobName}
                      rules={[{ required: true, message: "Enter date of birth" }]}
                    >
                      <DatePicker
                        className="w-full p-xs"
                        style={{ width: "100%" }}
                        placeholder="Enter date of birth"
                        format="MM/DD/YY"
                        value={minor.dob}
                        onChange={(date) => handleMinorChange(idx, "dob", date)}
                      />
                    </LabeledField>
                  </div>
                  {showDeleteButton && (
                    <Flex align="end" className="h-full" onClick={() => handleDeleteMinor(idx)}>
                      <IconWithBg className={styles.deleteIcon} height={18} width={18} icon={<Delete fill="#ff0000" />} />
                    </Flex>
                  )}
                </div>
              </React.Fragment>
            )
          })}
          <Button color="primary" variant="outlined" onClick={handleAddMinor}>
            {t("embedded.booking_confirmation.add_minor")}
          </Button>
          <Flex align="center" justify="space-between" gap={8} className="mt-4xl">
            <Flex align="center" gap={12}>
              {t("settings.powered_by")}
              <img src={logoSrc} alt="Digital Sportsman" className={styles.poweredLogo} />
            </Flex>
            <Flex align="center" gap={8}>
              <Button onClick={handleCancel} color="primary" variant="outlined">
                {t("embedded.booking_confirmation.previous")}
              </Button>
              <Button loading={postLoading} disabled={postLoading} color="primary" variant="solid" onClick={handleNext}>
                {t("embedded.booking_confirmation.next")}
              </Button>
            </Flex>
          </Flex>
        </Form>
      </Modal>
    </>
  )
}
